<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [class]="
    showAllIpRules || showIpRulesForm || showClientRulesForm ? 'd-none' : ''
  "
  [config]="pageConfig"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!--------------------------------------- btns --------------------------------------->
  <div class="card-toolbar" before-btns>
    <!-- ipRules btn -->
    <button
      type="button"
      class="btn txt-lg button-shadow tw-mx-1 tw-flex tw-items-center btn-hover-rise"
      [themeColor]="'btn-light'"
      mat-ripple
      (click)="onShowAllRules()"
    >
      <span class="tw-mx-1">{{ pageVocabs + "ipRules" | translate }}</span>
    </button>

    <!-- safe ips btn -->
    <button
      type="button"
      class="btn txt-lg button-shadow tw-mx-1 tw-flex tw-items-center btn-hover-rise"
      [themeColor]="'btn-light-info'"
      mat-ripple
      (click)="onShowSafeIps()"
    >
      <span class="tw-mx-1">{{ pageVocabs + "safeIps" | translate }}</span>
    </button>
  </div>

  <!---------------------------------------- Table Content ---------------------------------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- id -->
        <td class="tw-w-[10%]">
          <td-value copyToClipboard [value]="item?.id"></td-value>
        </td>

        <!-- ip -->
        <td class="msg-summary tw-text-center tw-cursor-pointer">
          <app-expand-text-click
            *ngIf="item?.ip != ''"
            [smallText]="item?.ip"
            [placement]="'left'"
            data-toggle="tooltip"
            direction="ltr"
            customClass="tw-text-left"
          >
            <span small-text>{{ item?.ip }}</span>
            <ng-container full-text>{{
              item?.ip | split | join : "\n"
            }}</ng-container>
          </app-expand-text-click>
          <td-value
            *ngIf="item?.ip == ''"
            copyToClipboard
            [value]="item?.ip"
          ></td-value>
        </td>

        <!-- token -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.token"
          ></td-value>
        </td>

        <!-- userName -->
        <td class="tw-w-[10%]">
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>

        <!-- status -->
        <td>
          <span [otpStatus]="item?.status" copyToClipboard>{{
            item?.status | enumToText : OtpStatusEnumValues
          }}</span>
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------------ operations ------------------------------------>
        <td class="sticky-td">
          <!-- open menu btn -->
          <div
            app-menu-btn
            [matMenuTriggerFor]="menu"
            [isShowDotsMenu]="true"
          ></div>

          <!-- menu -->
          <mat-menu #menu="matMenu" xPosition="before">
            <div
              *ngIf="userSession.organizationId() == 1"
              mat-menu-item
              color="gray"
              class="tw-flex-center text-gray border-bottom"
              (click)="onShowChangeStatus(item?.id, item.status)"
            >
              <i
                class="mdi mdi-arrow-collapse mdi-20px tw-ml-[10px] ltr:tw-mr-[10px]"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                "common.changeStatusTo" | translate
              }}</span>
            </div>

            <div
              mat-menu-item
              class="tw-flex-center text-warning border-bottom"
              (click)="onCreateRules('ipRules', item?.id)"
            >
              <i
                class="mdi mdi-ip-network mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-warning"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                pageVocabs + "createIpRules" | translate
              }}</span>
            </div>

            <div
              mat-menu-item
              class="tw-flex-center text-info border-bottom"
              (click)="onCreateRules('clientRules', item?.id)"
            >
              <i
                class="mdi mdi-account-settings mdi-20px tw-ml-[10px] ltr:tw-mr-[10px] text-info"
              ></i>
              <span class="mat-menu-title tw-font-medium">{{
                pageVocabs + "clientRules" | translate
              }}</span>
            </div>

            <div
              app-menu-btn
              icon="edit"
              (click)="
                organizationId = item?.organizationId; onUpdate(item?.id, false)
              "
            ></div>

            <div
              app-menu-btn
              icon="delete"
              (click)="onDelete(item.id, item.id)"
            ></div>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------- Audit --------------------------------------->

<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------- help --------------------------------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    menuTitle="Token"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!-- IpRulesForm -->
<ng-container *ngIf="showIpRulesForm">
  <app-ip-rules
    [model]="ipRulesModel"
    [apiTokenId]="apiTokenId"
    (closeFormPage)="getFormResponse($event)"
    (closePage)="
      showIpRulesForm = false;
      showParent = true;
      getParentQueryString();
      getEnumsValues()
    "
  >
  </app-ip-rules>
</ng-container>

<!-- ClientRulesForm -->
<ng-container *ngIf="showClientRulesForm">
  <app-client-rules
    [model]="clientRulesModel"
    [apiTokenId]="apiTokenId"
    (closeFormPage)="getFormResponse($event)"
    (closePage)="
      showClientRulesForm = false;
      showParent = true;
      getParentQueryString();
      getEnumsValues()
    "
  >
  </app-client-rules>
</ng-container>

<!-- AllIpRules -->
<ng-container *ngIf="showAllIpRules">
  <app-all-ip-rules
    [model]="allRulesModel"
    (closePage)="
      showAllIpRules = false;
      showParent = true;
      getParentQueryString();
      getEnumsValues()
    "
  >
  </app-all-ip-rules>
</ng-container>
